export const FREE_TIER = {
  name: "Free",
  name_icon: 'fa-battery-empty',
  img: {
    path: '0.svg',
    alt: 'divshow pricing free tier ',
  },
  card_border: '',
  most_popular: false,
  price_details: {
    monthly: {
      plan_key: null,
      price: "0 / month",
      description_subs: [
        "no card required",
      ],
    },
    yearly: {
      plan_key: null,
      price: "0",
      description_subs: [
        "no card required",
      ],
    }
  },
  description: "Evaluating product",
  features: [
    {"text": "1 show", "format": "strong"}, 
    "2 minute show duration",
    "2000 playbacks / month",
    "6 month retention",
    "Limited support",
    "Feedback results not collected",
  ],
  btn: {
    text: 'Login',
    class: 'btn-outline-quaternary',
    icon: "mr-2 fa fa-sign-in-alt",
    link: '/login',
  },
}

export const HOBBY_TIER = {
  name: "Hobby",
  name_icon: 'fa-battery-quarter',
  img: {
    path: '1.svg',
    alt: 'divshow pricing hobby tier ',
  },
  card_border: '',
  most_popular: false,
  price_details: {
    monthly: {
      plan_key: '20191118-hobby-monthly',
      price: "10 / month",
      description_subs: [
        // "annual cost: $120",
      ],    
    },
    yearly: {
      plan_key: '20191118-hobby-yearly',
      price: "9 / month",
      description_subs: [
        "billed annually @ $108",
      ],
    }
  },
  description: "Personal / Hobby apps",
  features: [
    {"text": "5 shows", "format": "strong"}, 
    "2 minute show duration",
    "Unlimited playbacks",
    "Email support",
    {"text": "High level feedback results collected", "format": "strong"}, 
  ],
  btn: {
    text: 'Login',
    class: 'btn-outline-quaternary',
    icon: "mr-2 fa fa-sign-in-alt",
    // link: '/login?dest=/billing?tier=hobby',
    link: '/login',
  },
}

export const STARTUP_TIER = {
  name: "Startup",
  name_icon: 'fa-battery-half',
  img: {
    path: '2.svg',
    alt: 'divshow pricing startup tier ',
  },
  card_border: 'box-shadow',
  most_popular: false,
  price_details: {
    monthly: {
      plan_key: '20191118-startup-monthly',
      price: "50 / month",
      description_subs: [
        // "annual cost: $600",
      ],    
    },
    yearly: {
      plan_key: '20191118-startup-yearly',
      price: "45 / month",
      description_subs: [
        "billed annually @ $540",
      ],
    }
  },
  description: "Small / Growing teams",
  features: [
    {"text": "30 shows", "format": "strong"}, 
    {"text": "3 minute show duration", "format": "strong"}, 
    "Unlimited playbacks",
    "Email support",
    "High level feedback results collected",
    {"text": "Customizable cursors - coming soon", "format": "strong"}, 
  ],
  btn: {
    text: 'Login',
    class: 'btn-outline-quaternary',
    icon: "mr-2 fa fa-sign-in-alt",
    // link: '/login?dest=/billing?tier=startup',
    link: '/login',
  },
}

export const SCALE_TIER = {
  name: "Scale",
  name_icon: 'fa-battery-three-quarters',
  img: {
    path: '3.svg',
    alt: 'divshow pricing scale tier ',
  },
  card_border: '',
  most_popular: false,
  price_details: {
    monthly: {
      plan_key: '20191118-scale-monthly',
      price: "150 / month",
      description_subs: [
        // "annual cost: $1800",
      ],
    },
    yearly: {
      plan_key: '20191118-scale-yearly',
      price: "135 / month",
      description_subs: [
        "billed annually @ $1620",
      ],
    }
  },
  description: "Medium / Large teams",
  features: [
    {"text": "150 shows", "format": "strong"}, 
    "3 minute show duration",
    "Unlimited playbacks",
    "Email and chat support",
    {"text": "Detailed feedback results collected", "format": "strong"}, 
    {"text": "Basic analytics", "format": "strong"}, 
    {"text": "Customizable cursors - coming soon", "format": "strong"}, 
  ],
  btn: {
    text: 'Login',
    class: 'btn-outline-quaternary',
    icon: "mr-2 fa fa-sign-in-alt",
    // link: '/login?dest=/billing?tier=scale',
    link: '/login',

    // text: 'Interested ?',
    // class: 'btn-outline-secondary',
    // icon: "mr-2 far fa-clock",
    // alert: 'This option is coming soon. Please contact us for details and precise pricing for your use case.',
  },
}

export const ENTERPRISE_TIER = {
  name: "Enterprise",
  name_icon: 'fa-battery-full',
  img: {
    path: '4.svg',
    alt: 'divshow pricing enterprise tier ',
  },
  card_border: '',
  most_popular: false,
  price_details: {
    monthly: {
      plan_key: 'contact-us',
      price: "Custom",
      description_subs: [
        "contact us for details",
      ],
    },
    yearly: {
      plan_key: 'contact-us',
      price: "Custom",
      description_subs: [
        "contact us for details",
      ],
    }
  },
  description: "Made for enterprises",
  features: [
    {"text": "Unlimited shows", "format": "strong"}, 
    "Flexible show duration",
    "Unlimited playbacks",
    "Dedicated support",
    "Analytics",
    // {"text": "Analytics and Reports", "format": "strong"}, 
    {"text": "Fully customizable branding", "format": "strong"}, 
    {"text": "Organization hierarchy", "format": "strong"}, 
    {"text": "Single sign-on (SSO)", "format": "strong"}, 
    // "Insight generation",    
  ],
  btn: {
    text: 'Contact us',
    class: 'btn-outline-quaternary',
    icon: "mr-2 fa fa-users",
    href: 'mailto:info@bytebeacon.com',
  },
}